import { useMutation } from '@tanstack/react-query'
import { useAPI } from '../../../Contexts/APIContext'

export const useManageOrganizationContent = () => {
  const { manageOrganizationContent } = useAPI()

  return useMutation({
    mutationFn: data =>
      manageOrganizationContent({
        ...data,
      }),
  })
}
